import { Component, OnInit } from '@angular/core';
import {ConfService} from '../../conf.service';
import {KongService} from '../../kong.service';
import {MatDialog} from '@angular/material';
import {FormControl} from '@angular/forms';
import {SettingsComponent} from '../settings.component';
import {PartnerOnboardComponent} from '../../partner-onboard/partner-onboard.component';
import {LeftpanelComponent} from '../../leftpanel/leftpanel.component';
declare let $;
@Component({
  selector: 'app-settings-top',
  templateUrl: './settings-top.component.html',
  styleUrls: ['./settings-top.component.scss']
})
export class SettingsTopComponent implements OnInit {
  hide = true;
  columns: any;
  item: any;
  currentPlanDisplayName: string;
  name: string;
  database: string;
  apiKeys: any;
  apiKeyData: any;
  apiKey: any;
  identityProvider = 'Active Directory';
  supportedIdps: any;
  Accounts = false;
  Databases = false;
  logo = false;
  myControl = new FormControl();
  constructor(private confPost: ConfService, public settingComp: PartnerOnboardComponent, public dialog: MatDialog, public platform: LeftpanelComponent) { }

  ngOnInit() {
    // this.settingComp.setcolumnvalues();
    if (this.platform.loadingForTheFirstTime === true && this.platform.loadingForTheFirstTimeCompleted === false) {
      this.platform.initialisePlatform();
    }
    this.apiKey = localStorage.getItem('apikey');
    this.confPost.getPartner(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(data => {
      this.item = data;
    });
  }
  copyMessage(val) {
    let selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = $(val).text();
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.platform.openSnackBar('Copied to clipboard.', 'Success', {
      duration: 5000,
      verticalPosition: 'top',
      horizontalPosition: 'center'
    });
  }
}
